import React from 'react';
import { Box, Icon, IconButton, Stack, Typography } from '@mui/material';
import { useLottie } from 'lottie-react';
import { useNavigate } from 'react-router-dom';

import MainCard from './cards/MainCard';
import { gridSpacing } from 'store/constant';

//icons
import { Refresh } from '@mui/icons-material';

import * as serviceUnavailableData from 'assets/animation/service-unavailable-503-astronaut.json';

const PageError = (props) => {
  const { height } = props;
  /**
   * Uses react-router-dom navigation
   */
  const navigate = useNavigate();

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: serviceUnavailableData,
  };
  const style = {
    minHeight: 200,
    minWidth: 200,
    height: height || 'calc(50vh - 4rem)',
    width: 'calc(50vw - 4rem)',
  };
  const { View } = useLottie(defaultOptions, style);
  /**
   * Navigate back to login
   */
  const handleRefreshPage = () => {
    navigate(-1)
    setTimeout(() => {
        //refresh page after going back page
        navigate(0)
    },[700])
  };


  return (
    <MainCard
      sx={{
        height: 'calc(100vh - 2rem)',
        width: 'calc(100vw - 5.5rem)',
        margin: '1rem',
        padding: '1rem',
        position: 'relative',
        border: 'none !important',
      }}
      border={false}
      shadow
    >
      <Stack
        direction="row"
        justifyContent="flex-end"
        spacing={gridSpacing}
        sx={(theme) => ({
          position: 'fixed',
          top: '1rem',
          right: '1rem',
          zIndex: theme.zIndex.fab,
          padding: gridSpacing,
        })}
      >
        <IconButton id="refreshPageIconBtn" onClick={handleRefreshPage}>
          <Refresh sx={{ fontSize: '5rem' }} />
        </IconButton>
      </Stack>
      <Box
        sx={{
          height: height ? height : 'calc(100vh - 4rem)',
          width: 'calc(100vw - 4rem)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {View}
      </Box>

      <Stack
        direction="row"
        sx={(theme) => ({
          position: 'fixed',
          bottom: '1rem',
          left: '0',
          zIndex: theme.zIndex.fab,
          width: '100%',
        })}
      >
        <Typography
          variant="caption"
          sx={(theme) => ({
            width: '100%',
            fontSize: '1.5rem !important',
            textAlign: 'center',
            fontFamily: 'monospace',
            color: `${theme.palette?.grey?.[400]} !important`,
          })}
        >
          Page is Unavailable. Go back to Previous Page or Refresh the Page to Try Again !
        </Typography>
      </Stack>
    </MainCard>
  );
};

export default PageError;
